module.exports = __webpack_public_path__ + "static/media/nr.8021b538.svg";